export default __webpack_public_path__ + "static/media/twitter.d6f78ee1.svg";